import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

class RadioGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { selected: props.selected };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev) {
    this.setState({ selected: ev.detail.value });
  }

  render() {
    const { children, name, ...props } = this.props;
    const { selected } = this.state;

    return (
      <StyledRadioGroup {...props}>
        {React.Children.map(children, child => (
          <StyledRadio
            key={child.props.value === selected}
            name={name}
            component={child}
            value={child.props.value}
            changeVal={this.handleChange}
            checked={child.props.value === selected}
          />
        ))}
      </StyledRadioGroup>
    );
  }
}

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
};

RadioGroup.defaultProps = {
  className: '',
  selected: null,
  onChange: Function.prototype,
};

const StyledRadioGroup = styled.div``;

const StyledRadio = styled(({ component, ...props }) =>
  React.cloneElement(component, props)
)``;

export default RadioGroup;
